<template>
  <div v-loading="loading">
    <apply-header :flag="'1'"></apply-header>
    <div class="parts">
      <div class="pageTitle">eAssist Application</div>
      <div class="mt20 pageTitleDes">
        CONGRATULATIONS! Your application has been received. Please complete all required prerequisite skills assessment tests before we can consider you for a position. The assessment tests must be completed in one sitting as you will not be able to save and finish them at a later time. We are
        looking forward to meeting you in the future. <br />Your answers and performance scores are summaries below.
      </div>

      <div class="testDetail">
        <div class="section" v-if="applyVersion == 2">
          <div v-if="!colorTestCompleted" class="pageSectionTitle">Color Code Result:</div>
          <u v-else class="pageSectionTitle" style="cursor: pointer" @click="seeColorResult">Color Code Result:</u>
          <div class="mt10" style="font-size: 13px" v-if="colorTestCompleted">
            <span>Red:{{ colorTestRedNum }},</span><span class="ml10">Blue:{{ colorTestBlueNum }},</span> <span class="ml10">White:{{ colorTestWhiteNum }},</span><span class="ml10">Yellow:{{ colorTestYellowNum }}</span>
          </div>
          <el-button v-else class="yellowBtn" size="small" @click="colorTest">Start Test</el-button>
        </div>

        <div class="section" v-if="applyVersion == 2">
          <div v-if="!hollandTestCompleted" class="pageSectionTitle">Holland Personality Result:</div>
          <u v-else class="pageSectionTitle" style="cursor: pointer" @click="seeHollandResult">Holland Personality Result:</u>
          <div class="mt10" style="font-size: 13px" v-if="hollandTestCompleted">
            <span>Realistic:{{ realisticNum }},</span><span class="ml10">Investigative:{{ investigativeNum }},</span> <span class="ml10">Artistic:{{ artisticNum }},</span><span class="ml10">Social:{{ socialNum }}</span> <span class="ml10">Enterprising:{{ enterprisingNum }}</span
            ><span class="ml10">Conventional:{{ conventionalNum }}</span>
          </div>
          <el-button v-else class="yellowBtn" size="small" @click="HollandTest">Start Test</el-button>
        </div>

        <div class="section" v-if="applyVersion >=2">
          <div v-if="!questionnaireCompleted" class="pageSectionTitle">What If Questionnaire Result:</div>
          <u v-else class="pageSectionTitle" style="cursor: pointer" @click="seeQuestionnaireResult(0)">What If Questionnaire Result:</u>
          <div class="mt10" v-if="questionnaireCompleted" style="font-size: 13px">You have complete the Questionnaire.</div>
          <div class="mt10" v-else>
            <el-button class="yellowBtn mt10" size="small" @click="seeQuestionnaireResult(1)">Start Test</el-button>
          </div>
        </div>
        <div class="section" v-if="applyVersion == 3&&resiliencyTestResult&&resiliencyTestResult.score">
          <u class="pageSectionTitle" style="cursor: pointer" @click="seeResiliencyResult">Resiliency Test Result:</u>
          <div class="mt10" style="font-size: 13px">
            <span>Routine (Task) Performance:{{ resiliencyTestResult.score.task }},</span>
            <span class="ml10">Teamplayer ("Citizenship") Performance:{{ resiliencyTestResult.score.ocb }},</span>
            <span class="ml10">Adaptive:{{ resiliencyTestResult.score.adapt }},</span>
            <span class="ml10">Resilience:{{ resiliencyTestResult.score.resil }},</span>
            <span class="ml10">CWB:{{ resiliencyTestResult.score.cwb }},</span>
            <span class="ml10">LDR EMERGENCE:{{ resiliencyTestResult.score.ldR_EMERGE }},</span>
            <span class="ml10">LDR EFFECTIVENESS:{{ resiliencyTestResult.score.ldR_EFFECT }}</span>
          </div>
          <!-- <el-button v-else class="yellowBtn" size="small" @click="resiliencyTest">Start Test</el-button> -->
        </div>

        <div class="pageSectionTitle">Service Test Result:</div>
        <div class="section">
          <div v-for="(item, index) in serviceTestList" :key="index" v-show="hasTested">
            <div class="textBox">
              <div class="testTitle">{{ item.serviceName }} Test</div>
              <div class="status" v-if="item.status == 2 || item.status == 3">{{ percent(item) }}</div>
              <div class="status" v-else>Not Completed</div>
            </div>
          </div>
          <div style="clear: both; margin-top: 20px"></div>
          <!---When not finish any test-->
          <el-button class="yellowBtn" size="small" @click="gotoService" :disabled="!questionnaireCompleted && applyVersion>2" v-if="!hasTested">
            <span>Start Test </span>
            <el-tooltip v-show="!questionnaireCompleted && applyVersion>2" class="item" effect="dark" content="Please Complete The Questionnaire And Resiliency Test First!" placement="top">
                    <i class="el-icon-warning-outline"></i> 
            </el-tooltip>
        </el-button>
          <!---When at least finish one test-->
          <el-button class="yellowBtn" size="small" @click="gotoService" v-if="hasTested">Apply for more services</el-button>
        </div>
      </div>

      <div class="pageTitleDes" style="margin-top: 20px">
        Thank you for you interest in this opportunity, We are looking forward to developing a relationship with you in the future.
        <br />
        <!--
        eAssist is an equal opportunity employer and affords equal opportunity to all applicants for all positions without regard to race,color,religion,gender,national, origin,age,disability,veteran status or any other status protected under local,state or federal laws.
        -->
      </div>
    </div>
  </div>
</template>

<script>
import ApplyHeader from "../../components/ApplyHeader";
export default {
  name: "applicantHome",
  components: { ApplyHeader },
  data() {
    return {
      serviceTestList: [],
      hasTested: false, //是否有一项测试过
      loading: false,
      questionnaireCompleted: false,
      colorTestCompleted: false,
      colorTestRedNum: 0,
      colorTestBlueNum: 0,
      colorTestWhiteNum: 0,
      colorTestYellowNum: 0,

      hollandTestCompleted: false,

      realisticNum: 0,
      investigativeNum: 0,
      artisticNum: 0,
      socialNum: 0,
      enterprisingNum: 0,
      conventionalNum: 0,

      // dentalBillCompleted:false,
      // dentalBillPercent:'0%',
      eobCompleted: false,
      eobPercent: "0%",

      radiograhpyCompleted: false,
      radiograhpyPercent: "0%",

      claimCompleted: false,
      claimPercent: "0%",

      insuranceCompleted: false,
      insurancePercent: "0%",

      ohodonticCompleted: false,
      ohodonticPercent: "0%",

      medicalCompleted: false,
      medicalPercent: "0%",

      oralSurgeryCompleted: false,
      oralSurgeryPercent: "0%",

      //2024/3/12需求  新用户或者没有进行resiliency Test的用户不再展示入口，如果已做测试的用户还能查看历史测试数据
    //   resiliencyTestCompleted: false,
      resiliencyTestResult: null,

      applyVersion: 5,
    };
  },
  created() {
    let version = localStorage.getItem("version");
    if (version != undefined) {
      this.applyVersion = parseInt(version);
    }
    this.getData();
  },
  computed: {
    percent() {
      return function (item) {
        if (item.possible == 0) return "0%";
        return Number((item.score * 100) / item.possible).toFixed(2) + "%";
      };
    },
  },
  methods: {
    getApplyPositionFlag(){
        // var email = localStorage.getItem("email");
        // if(!email)return
        // this.$axios.get(this.$URL.applyInfo,{params:{email:email}}).then(res=>{
        //     if(res.code==0){
        //         let data = res.data
        //         localStorage.setItem('applyPosition',data.applyPosition)
        //     }
        // }).catch(err=>{
        //     this.$message.error({message:err})
        // })
    },
    //当用户在apply的时候applyPosition选了Dental Accounting，则需要引导到新的whatif页面
    seeQuestionnaireResult(flag) {
        // let applyPosition = localStorage.getItem('applyPosition')||''
        // if(applyPosition=='Dental Accounting'){
        //     this.$router.push({path:'/newWhatIf',query:{type:flag}})
        // }else{
        //     this.$router.push({ path: "/testBoard", query: { type: flag } });
        // }
        if(this.applyVersion>=4){
            this.$router.push({ path:'/whatIfv4', query: { type: flag } })
        }else{
            this.$router.push({ path: "/testBoard", query: { type: flag } });
        }
    },
    seeColorResult() {
      this.$router.push({ path: "/colorTest" });
    },
    seeHollandResult() {
      this.$router.push({ path: "/hollandTest" });
    },
    seeResiliencyResult() {
      this.$router.push({ path: "/resiliencyBoard" });
    },
    getData() {
      this.getServiceData();
      this.getApplyPositionFlag()
      if (this.applyVersion >= 2) {
        this.getQuestionnaireData();
      }
      if (this.applyVersion > 2) {
        this.getResiliencyTestData();
      } else {
        this.getColorTestData();
        this.getHollandTestData();
      }
    },
    colorTest() {
      console.log("color Test!");
      this.$router.push({ path: "/colorTest" });
    },
    HollandTest() {
      console.log("Holland Test!");
      this.$router.push({ path: "/hollandTest" });
    },
    resiliencyTest() {
      console.log("Resiliency Test!");
      this.$router.push({ path: "/resiliencyBoard" });
    },
    gotoService() {
      this.$router.push({ path: "/service",query:{questionnaireCompleted:false} });
    },
    getServiceData() {
      var email = localStorage.getItem("email");
      this.loading = true;
      this.$axios
        .get(this.$URL.serviceUrl, { params: { email: email } })
        .then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            var data = res.data;
            if (data && data.length > 0) this.serviceTestList = data;
            // console.log("返回来的数据", data);
            for (var i = 0; i < this.serviceTestList.length; i++) {
              var item = this.serviceTestList[i];
              if (item.status == 2 || item.status == 3) {
                this.hasTested = true;
                break;
              }
            }
          } else {
            this.$message.error({ message: res.msg });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error({ message: err });
        });
    },
    getColorTestData() {
      var email = localStorage.getItem("email");
      this.$axios
        .get(this.$URL.colorTestUrl, { params: { email: email } })
        .then((res) => {
          if (res && res.code == 0) {
            if (res.data) {
              this.colorTestCompleted = true;
              this.colorTestRedNum = res.data.red;
              this.colorTestBlueNum = res.data.blue;
              this.colorTestWhiteNum = res.data.white;
              this.colorTestYellowNum = res.data.yellow;
            }
          }
        })
        .catch((err) => {
          this.$message.error({ message: err });
        });
    },
    getQuestionnaireData() {
      var email = localStorage.getItem("email");
      //这里如果完成了whatif则把这个标志存起来到service页面再使用
      localStorage.setItem('whatIf',false)
      this.$axios.get(this.$URL.testBoardUrl, { params: { email: email } }).then((res) => {
        console.log(res);
        if (res && res.code == 0) {
          if (res.data && res.data != null) {
            this.questionnaireCompleted = true;
            localStorage.setItem('whatIf',true)
          }
        }
      });
    },
    getHollandTestData() {
      var email = localStorage.getItem("email");
      this.$axios
        .get(this.$URL.hollandTestUrl, { params: { email: email } })
        .then((res) => {
          if (res && res.code == 0) {
            if (res.data) {
              this.hollandTestCompleted = true;
              this.realisticNum = res.data.realistic || 0;
              this.investigativeNum = res.data.investigative || 0;
              this.artisticNum = res.data.artistic || 0;
              this.socialNum = res.data.social || 0;
              this.enterprisingNum = res.data.enterprising || 0;
              this.conventionalNum = res.data.conventional || 0;
            }
            console.log("bbb", res.data);
          }
        })
        .catch((err) => {
          this.$message.error({ message: err });
        });
    },
    getResiliencyTestData() {
      var email = localStorage.getItem("email");
      this.$axios.get(this.$URL.resiliencyBoardUrl + "/result", { params: { email: email } }).then((res) => {
        console.log(res);
        if (res && res.code == 0) {
            this.resiliencyTestResult = res.data;
        }
      });
    },
  },
  watch: {
    $route(to, from) {
      console.log(from);
      if (to.path === "/applicantHome") {
        this.getData();
      }
    },
  },
};
</script>

<style scoped>
.parts {
  width: 80%;
  margin: 10px auto 0;
  background: #fff;
}
.testDetail {
  padding: 10px;
  border: 1px solid #c2c2c6;
  margin-top: 25px;
  border-radius: 4px;
}
.testTitle {
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
}
.textBox {
  margin-left: 50px;
  margin-top: 20px;
}
.textBoxChild {
  margin-left: 80px;
  margin-top: 20px;
}
.status {
  font-size: 13px;
  margin-top: 10px;
}
.section {
  margin-bottom: 30px;
  padding-bottom: 10px;
  border-bottom: 1px dotted grey;
}
</style>